import { useEffect } from 'react'

import { popularFetcher } from '@/libs/fetcher/presets'
import { CoinId, VisitType } from '@/types/coin'

export default function useVisitCoin(coinId: CoinId) {
  useEffect(() => {
    popularFetcher('/visit', {
      method: 'POST',
      body: {
        type: VisitType.Token,
        key: coinId,
      },
    })
  }, [coinId])
}
